import { Injectable, inject } from '@angular/core';

import { firstValueFrom } from 'rxjs';

import { ApiService, IDeliveryCalendarDay, IOutletCalendarDay } from '@cakeiteasy/web-utils';

/**The returnable-items calendars are their own endpoints: they answer "when can this packaging come
 * back". Scoped to the session's cart like the delivery calendars beside them, so neither takes an
 * id — only what is being returned to, and when.
 * */
@Injectable({ providedIn: 'root' })
export class ReturnPackagingApiService {
  private readonly _api = inject(ApiService);

  public getOutletCalendar(outletId: number, year: number, month: number): Promise<IOutletCalendarDay[]> {
    return firstValueFrom(this._api.get('api.cart', 'returnable_items_outlet_calendar',
      null, { params: { outlet: outletId, year, month } }));
  }

  public getDeliveryCalendar(postNumber: string, year: number, month: number): Promise<IDeliveryCalendarDay[]> {
    return firstValueFrom(this._api.get('api.cart', 'returnable_items_delivery_calendar',
      null, { params: { postNumber, year, month } }));
  }
}
